import { Checkbox } from 'antd';
import { GoBack, Location, MultiFamily, SingleFamily, Vacation } from '../../assets/icons';

export const sortData = [
  {
    value: 'Newest',
    label: (
      <>
        <div className='d-flex align-items-center'>
          <span className='text-taupe mr-4'>Sort by: </span>
          <span>Newest</span>
        </div>
      </>
    ),
  },
  {
    value: 'Trending',
    label: (
      <>
        <div className='d-flex align-items-center'>
          <span className='text-taupe mr-4'>Sort by: </span>
          <span>Trending</span>
        </div>
      </>
    ),
  },
  {
    value: 'Almost funded',
    label: (
      <>
        <div className='d-flex align-items-center'>
          <span className='text-taupe mr-4'>Sort by: </span>
          <span>Almost Funded</span>
        </div>
      </>
    ),
  },
  {
    value: 'Lowest price',
    label: (
      <>
        <div className='d-flex align-items-center'>
          <span className='text-taupe mr-4'>Sort by: </span>
          <span>Lowest Price</span>
        </div>
      </>
    ),
  },
  {
    value: 'Highest price',
    label: (
      <>
        <div className='d-flex align-items-center'>
          <span className='text-taupe mr-4'>Sort by: </span>
          <span>Highest Price</span>
        </div>
      </>
    ),
  },
];

export const sortDataWithoutFunded = [
  {
    value: 'Newest',
    label: (
      <>
        <div className='d-flex align-items-center'>
          <span className='text-taupe mr-4'>Sort by: </span>
          <span>Newest</span>
        </div>
      </>
    ),
  },
  {
    value: 'Trending',
    label: (
      <>
        <div className='d-flex align-items-center'>
          <span className='text-taupe mr-4'>Sort by: </span>
          <span>Trending</span>
        </div>
      </>
    ),
  },
  {
    value: 'Lowest price',
    label: (
      <>
        <div className='d-flex align-items-center'>
          <span className='text-taupe mr-4'>Sort by: </span>
          <span>Lowest Price</span>
        </div>
      </>
    ),
  },
  {
    value: 'Highest price',
    label: (
      <>
        <div className='d-flex align-items-center'>
          <span className='text-taupe mr-4'>Sort by: </span>
          <span>Highest Price</span>
        </div>
      </>
    ),
  },
];

export const chartData = [
  {
    pv: 2400,
    amt: 2400,
  },
  {
    pv: 1398,
    amt: 2210,
  },
  {
    pv: 9800,
    amt: 2290,
  },
  {
    pv: 3908,
    amt: 2000,
  },
  {
    pv: 4800,
    amt: 2181,
  },
  {
    pv: 3800,
    amt: 2500,
  },
  {
    pv: 4300,
    amt: 2100,
  },
  {
    pv: 2400,
    amt: 2400,
  },
  {
    pv: 1398,
    amt: 2210,
  },
  {
    pv: 9800,
    amt: 2290,
  },
  {
    pv: 3908,
    amt: 2000,
  },
  {
    pv: 4800,
    amt: 2181,
  },
  {
    pv: 3800,
    amt: 2500,
  },
  {
    pv: 4300,
    amt: 2100,
  },
  {
    pv: 2400,
    amt: 2400,
  },
  {
    pv: 1398,
    amt: 2210,
  },
  {
    pv: 9800,
    amt: 2290,
  },
  {
    pv: 3908,
    amt: 2000,
  },
  {
    pv: 4800,
    amt: 2181,
  },
  {
    pv: 3800,
    amt: 2500,
  },
  {
    pv: 4300,
    amt: 2100,
  },
];
export const searchData = [
  {
    label: 'Recent Searches',
    options: [
      {
        label: (
          <>
            <GoBack />
            <span>Ma</span>
          </>
        ),
        value: 'ma',
      },
      {
        label: (
          <>
            <GoBack />
            <span>Miami</span>
          </>
        ),
        value: 'miami',
      },
      {
        label: (
          <>
            <GoBack />
            <span>Florida</span>
          </>
        ),
        value: 'florida',
      },
      {
        label: (
          <>
            <GoBack />
            <span>The Rodriguez</span>
          </>
        ),
        value: 'rodriguez',
      },
      {
        label: (
          <>
            <GoBack />
            <span>Boca</span>
          </>
        ),
        value: 'boca',
      },
    ],
  },
  {
    label: 'Search Result',
    options: [
      {
        label: (
          <>
            <Location verticalAlign='-8px' />
            <span>state: </span>
            <span className='fw-600'>Massachusetts</span>
          </>
        ),
        value: 'massachusetts',
      },
      {
        label: (
          <>
            <Location verticalAlign='-8px' />
            <span>city: </span>
            <span className='fw-600'>Boston, MA</span>
          </>
        ),
        value: 'boston',
      },
      {
        label: (
          <>
            <Location verticalAlign='-8px' />
            <span>city: </span>
            <span className='fw-600'>Cambridge, MA</span>
          </>
        ),
        value: 'cambridge',
      },
      {
        label: (
          <>
            <Location verticalAlign='-8px' />
            <span>city: </span>
            <span className='fw-600'>Madison, WI</span>
          </>
        ),
        value: 'madison',
      },
      {
        label: (
          <>
            <MultiFamily marginRight='4px' verticalAlign='-8px' />
            <span className='fw-600'>The Martin</span>
          </>
        ),
        value: 'martin',
      },
      {
        label: (
          <>
            <Vacation />
            <span className='fw-600'>The Maurice</span>
          </>
        ),
        value: 'maurice',
      },
      {
        label: (
          <>
            <SingleFamily verticalAlign='-8px' marginRight='4px' />
            <span className='fw-600'>The Maggie</span>
          </>
        ),
        value: 'maggie',
      },
      {
        label: (
          <>
            <MultiFamily marginRight='4px' verticalAlign='-8px' />
            <span className='fw-600'>The Masa</span>
          </>
        ),
        value: 'masa',
      },
    ],
  },
];

export const locationData = [
  {
    label: (
      <Checkbox>
        New York, NY <span className='text-taupe-80'></span>
      </Checkbox>
    ),
    value: 'new york',
  },
  {
    label: (
      <Checkbox>
        New Brunswick, NJ <span className='text-taupe-80'></span>
      </Checkbox>
    ),
    value: 'miami',
  },
  {
    label: (
      <Checkbox>
        Newport, RI <span className='text-taupe-80'></span>
      </Checkbox>
    ),
    value: 'florida',
  },
  {
    label: (
      <Checkbox>
        Newport Ceach, CA <span className='text-taupe-80'></span>
      </Checkbox>
    ),
    value: 'rodriguez',
  },
  {
    label: (
      <Checkbox>
        New Orleans, LA <span className='text-taupe-80'></span>
      </Checkbox>
    ),
    value: 'boca',
  },
];
